import { BANNER_TYPES } from '../../../types/index.js';

const normalizeBannerFromService = (banner) => {
    const type = Object.entries(BANNER_TYPES).find(([_, value]) => value.toLowerCase() === banner.bannerType.toLowerCase())?.[1];
    return { ...banner, bannerType: type ?? banner.bannerType };
};

export { normalizeBannerFromService };
//# sourceMappingURL=normalizeBannerFromService.js.map
